var _g, _path, _path2, _line, _line2, _line3, _line4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCourtMat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1367,
    height: 176,
    viewBox: "0 0 1367 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.851 1.05048e-07L1147.14 5.34062e-07L1363 156.281L4 156.281L228.851 1.05048e-07Z",
    fill: "url(#paint0_linear_77_125)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.851 3.02794e-08L1147.14 3.81873e-07L1283.61 98.978L149.767 55.1325L228.851 3.02794e-08Z",
    fill: "url(#paint1_linear_77_125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.915 118.42L239.718 32.6516L1135.31 32.6516L1246.33 118.42L127.915 118.42Z",
    stroke: "#E3EBD6",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -4,
    x2: 94.2295,
    y2: -4,
    transform: "matrix(-0.466462 0.884541 -0.896558 -0.442925 481.22 32.1245)",
    stroke: "#E3EBD6",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -4,
    x2: 94.2295,
    y2: -4,
    transform: "matrix(0.466462 0.884541 0.896558 -0.442925 895.647 32.1245)",
    stroke: "#E3EBD6",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 188.788,
    y1: 72.4041,
    x2: 464.176,
    y2: 72.4041,
    stroke: "#E3EBD6",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 911.794,
    y1: 72.4041,
    x2: 1187.18,
    y2: 72.4041,
    stroke: "#E3EBD6",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_125",
    x: 0,
    y: 0,
    width: 1367,
    height: 175.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_125",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_125",
    x1: 699.647,
    y1: 156.281,
    x2: 727.858,
    y2: -0.331286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333961,
    stopColor: "#00C035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876271,
    stopColor: "#00AA6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_125",
    x1: 716.69,
    y1: 2.17062e-7,
    x2: 716.69,
    y2: 98.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.299965,
    stopColor: "#3BA558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985057,
    stopColor: "#38B25A",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCourtMat);
export default __webpack_public_path__ + "static/media/green-court-mat.ab54c177a8d7f256479b9fe065eefc89.svg";
export { ForwardRef as ReactComponent };